<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <div class="native-date-wrapper">
    <input
      (blur)="control.markAsTouched()"
      (change)="onDateChange($event)"
      [value]="value"
      class="native-date-input w-full px-2 py-3"
      type="date"
      [id]="inputId"
      [attr.aria-label]="inputAriaLabel"
      [attr.aria-invalid]="control.invalid && control.touched ? 'true' : 'false'"
      [attr.aria-describedby]="
        control.hasError('required') && control.touched ? validatorId : null
      "
    />
    <span class="native-date-input-icon" aria-hidden="true"></span>
  </div>
  @if (control.hasError("required") && control.touched) {
    <div [id]="validatorId" role="alert">
      <app-validator
        [question]="question"
        [validator]="ValidatorType.RequiredSelect"
      />
    </div>
  }
</app-question-base>
